import './Footer.scss';

export default function Footer() {

    return (
      <>
        <footer>
            <div className="contact-info">
                <h4>Contact</h4>
                <a href="">healthywithdaphne@outlook.com</a>
                <a href="">06-17449877</a>
            </div>
            <div className="copyright">
                © {(new Date().getFullYear())} Daphne van der Kooi
            </div>
        </footer>
    </>
    );
  }